import axios from "axios";
import {
  ragAnalytics
} from "../api/endpoints";
import Duck from "extensible-duck";
import generateExcelReport from "../utils/generateReport";


export default new Duck({
  namespace: "BatAnalytics",
  store: "ragscore",
  types: ["IS_LOADING", "GET_RAG_SCORE", "GET_TOTAL_SCORE", "GET_THINGS", "GET_GROUPS" , "GET_VIOLATIONS"],
  initialState: {
    isLoading: false,
    analytics: null,
    accumulativeAnalytics: null,
    things: null,
    groupList: null,
    cardinalViolations:null,
  },
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.IS_LOADING:
        return {
          ...state,
          isLoading: action.isLoading,
        }
      case duck.types.GET_RAG_SCORE:
        return {
          ...state,
          analytics: action.analytics,
          accumulativeAnalytics: action.accumulativeAnalytics === undefined ? null : action.accumulativeAnalytics
        }
      case duck.types.GET_TOTAL_SCORE:
        return {
          ...state,
          accumulativeAnalytics: action.accumulativeAnalytics
        }
      case duck.types.GET_THINGS:
        return {
          ...state,
          things: action.things
        }
      case duck.types.GET_GROUPS:
        return {
          ...state,
          groupList: action.groupList
        }
        case duck.types.GET_VIOLATIONS:
        return {
          ...state,
          cardinalViolations: action.cardinalViolations
        }
      default:
        return state;
    }
  },
  selectors: {
    root: (state) => state,
  },
  creators: (duck) => ({
    // getViolations: (id, data) => async (dispatch, getState) => {
    //   try {
    //     dispatch({ type: duck.types.GET_RAG_SCORE, analytics: null , accumulativeAnalytics: null});
    //     dispatch({ type: duck.types.IS_LOADING, isLoading: true });
    //     const response = await axios.post(ragAnalytics.ragscore, {
    //       id,
    //       data
    //     });
    //     dispatch({ type: duck.types.IS_LOADING, isLoading: false });
    //     if (response.data.data.mergedArray) {
    //       if (response.data.data.mergedArray.length === 1) {
    //         const formattedArray = response.data.data.mergedArray.map(obj => [
    //           { name: 'Harsh Accelerations per 100 km', value: parseFloat(obj?.parameterA) },
    //           { name: 'Harsh Brakes per 100 km', value: parseFloat(obj?.parameterB) },
    //           { name: 'Over Speeding Score per 100 km', value: parseFloat(obj?.parameterC) },
    //           { name: 'Total RAG Score', value: parseFloat(obj?.totalRagScore) }
    //         ]);
    //         dispatch({ type: duck.types.GET_RAG_SCORE, analytics: formattedArray });
    //       }
    //       else if (response.data.data.mergedArray.length > 1) {
    //         const formattedArray = response.data.data.mergedArray.map(obj => [
    //           obj.plateNumber,
    //           { name: 'Harsh Accelerations per 100 km', value: parseFloat(obj?.parameterA) },
    //           { name: 'Harsh Brakes per 100 km', value: parseFloat(obj?.parameterB) },
    //           { name: 'Over Speeding Score per 100 km', value: parseFloat(obj?.parameterC) },
    //           { name: 'Total RAG Score', value: parseFloat(obj?.totalRagScore) }
    //         ]);
    //         let sum = parseFloat(response?.data?.data?.accumulativeAnalytics?.totalParameterA) +
    //         parseFloat(response?.data?.data?.accumulativeAnalytics?.totalParameterB) + 
    //         parseFloat(response?.data?.data?.accumulativeAnalytics?.totalParameterC);
    //         const finalSum = sum.toFixed(2)
    //         let Data = [
    //           { name: 'Harsh Accelerations per 100 km', value: parseFloat(response?.data?.data?.accumulativeAnalytics?.totalParameterA) },
    //           { name: 'Harsh Brakes per 100 km', value: parseFloat(response?.data?.data?.accumulativeAnalytics?.totalParameterB) },
    //           { name: 'Over Speeding Score per 100 km', value: parseFloat(response?.data?.data?.accumulativeAnalytics?.totalParameterC) },
    //           { name: 'Total RAG Score' , value: parseFloat(finalSum)},
    //           { name: 'SD', value: response?.data?.data?.accumulativeAnalytics?.totalRagScorePopulation },
    //         ]
    //         dispatch({ type: duck.types.GET_RAG_SCORE, analytics: formattedArray, accumulativeAnalytics: Data });
    //       }
    //     }
    //     else {
    //       let inputObject = response.data.data[0];
    //       let parameterA = parseFloat(inputObject?.parameterA);
    //       let parameterB = parseFloat(inputObject?.parameterB);
    //       let parameterC = parseFloat(inputObject?.parameterC);
    //       let totalRagScore = parseFloat(inputObject?.totalRagScore);
    //       let Data = [[
    //         { name: 'Harsh Accelerations per 100 km', value: parameterA },
    //         { name: 'Harsh Brakes per 100 km', value: parameterB },
    //         { name: 'Over Speeding Score per 100 km', value: parameterC },
    //         { name: 'Total RAG Score', value: totalRagScore }
    //       ]
    //       ];
    //       dispatch({ type: duck.types.GET_RAG_SCORE, analytics: Data });
    //     }
    //   } catch (error) { }
    // },
    getViolations: (id, data) => async (dispatch, getState) => {
      try {
        dispatch({ type: duck.types.GET_RAG_SCORE, analytics: null, accumulativeAnalytics: null });
        dispatch({ type: duck.types.IS_LOADING, isLoading: true });
    
        const response = await axios.post(ragAnalytics.ragscore, { id, data });
    
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });
    
        if (response.data.data.mergedArray) {
          const mergedArray = response.data.data.mergedArray;
    
          if (mergedArray.length === 1) {
            const formattedArray = mergedArray.map(obj => {
              const values = [
                { name: 'Harsh Accelerations per 100 km', value: parseFloat(obj?.parameterA) },
                { name: 'Harsh Brakes per 100 km', value: parseFloat(obj?.parameterB) },
                { name: 'Over Speeding Score per 100 km', value: parseFloat(obj?.parameterC) },
                { name: 'Total RAG Score', value: parseFloat(obj?.totalRagScore) }
              ];
              return values.filter(item => Number.isFinite(item.value));
            });
            dispatch({ type: duck.types.GET_RAG_SCORE, analytics: formattedArray });
          }
    
          else if (mergedArray.length > 1) {
            const formattedArray = mergedArray.map(obj => {
              const values = [
                { name: 'Harsh Accelerations per 100 km', value: parseFloat(obj?.parameterA) },
                { name: 'Harsh Brakes per 100 km', value: parseFloat(obj?.parameterB) },
                { name: 'Over Speeding Score per 100 km', value: parseFloat(obj?.parameterC) },
                { name: 'Total RAG Score', value: parseFloat(obj?.totalRagScore) }
              ];
              return [obj.plateNumber, ...values.filter(item => Number.isFinite(item.value))];
            });
    
            const accum = response?.data?.data?.accumulativeAnalytics || {};
            const paramA = parseFloat(accum?.totalParameterA);
            const paramB = parseFloat(accum?.totalParameterB);
            const paramC = parseFloat(accum?.totalParameterC);
            
            let sum = paramA + paramB + paramC;
            let finalSum = Number.isFinite(sum) ? sum.toFixed(2) : null;
            
            let accumArray = [];
            
            if (!Number.isFinite(paramA) && !Number.isFinite(paramB) && Number.isFinite(paramC)) {
             
              accumArray = [
                { name: 'Total RAG Score', value: paramC }
              ];
            } else {
      
              accumArray = [
                { name: 'Harsh Accelerations per 100 km', value: paramA },
                { name: 'Harsh Brakes per 100 km', value: paramB },
                { name: 'Over Speeding Score per 100 km', value: paramC },
                { name: 'Total RAG Score', value: parseFloat(finalSum) },
                { name: 'SD', value: parseFloat(accum?.totalRagScorePopulation) }
              ].filter(item => Number.isFinite(item.value));
            }
    
            dispatch({ type: duck.types.GET_RAG_SCORE, analytics: formattedArray, accumulativeAnalytics: accumArray });
          }
        }
    
        else if (Array.isArray(response.data.data) && response.data.data.length > 0) {
          const obj = response.data.data[0];
          const values = [
            { name: 'Harsh Accelerations per 100 km', value: parseFloat(obj?.parameterA) },
            { name: 'Harsh Brakes per 100 km', value: parseFloat(obj?.parameterB) },
            { name: 'Over Speeding Score per 100 km', value: parseFloat(obj?.parameterC) },
            { name: 'Total RAG Score', value: parseFloat(obj?.totalRagScore) }
          ];
          const filteredData = [values.filter(item => Number.isFinite(item.value))];
          dispatch({ type: duck.types.GET_RAG_SCORE, analytics: filteredData });
        }
    
      } catch (error) {
        console.error("Error in getViolations:", error);
      }
    },

    getViolationsAndDownloadReport: (id, data) => async (dispatch) => {
      try {
        dispatch({ type: duck.types.GET_RAG_SCORE, analytics: null, accumulativeAnalytics: null });
        dispatch({ type: duck.types.IS_LOADING, isLoading: true });
    
        const response = await axios.post(ragAnalytics.ragscore, { id, data });
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });
    
        const startDate = data?.selection?.startDate;
        const endDate = data?.selection?.endDate;
        const startTime = startDate ? startDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) : "";
        const endTime = endDate ? endDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) : "";
    
        let formattedArray = [];
    
        const buildRow = (obj) => {
          const row = {};
    
          if (obj?.plateNumber) row['Vehicle'] = obj.plateNumber;
          if (Number.isFinite(parseFloat(obj?.parameterA))) row['Harsh Accelerations per 100 km'] = parseFloat(obj.parameterA);
          if (Number.isFinite(parseFloat(obj?.parameterB))) row['Harsh Brakes per 100 km'] = parseFloat(obj.parameterB);
          if (Number.isFinite(parseFloat(obj?.parameterC))) row['Over Speeding Score per 100 km'] = parseFloat(obj.parameterC);
          if (Number.isFinite(parseFloat(obj?.totalRagScore))) row['Total RAG Score'] = parseFloat(obj.totalRagScore);
    
          return row;
        };
    
        const mergedArray = response.data?.data?.mergedArray;
        if (mergedArray && Array.isArray(mergedArray)) {
          formattedArray = mergedArray.map(buildRow);
        } else if (Array.isArray(response.data?.data)) {
          formattedArray.push(buildRow(response.data.data[0]));
        }
    
        const allKeys = new Set();
        formattedArray.forEach(row => Object.keys(row).forEach(key => allKeys.add(key)));
        const headers = Array.from(allKeys);
        
        generateExcelReport(
          formattedArray,
          "rag_score_report",
          startDate?.toISOString().split('T')[0],
          endDate?.toISOString().split('T')[0],
          startTime,
          endTime,
          headers
        );
    
      } catch (error) {
        console.error('Error generating report:', error);
      }
    }
,    
    
 
    getThings: () => async (dispatch) => {
      try {
        dispatch({ type: duck.types.GET_RAG_SCORE, analytics: null , accumulativeAnalytics: null});
      
        let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
       
        const companyId = companyInfo.companyId;

        let data = {
          companyId
        }
        
        
        const things = await axios.get(ragAnalytics.getThings , {params:data} )
        dispatch({ type: duck.types.GET_THINGS, things: things.data.data });
      } catch (error) {

      }
    },
    getSubGroups: () => async (dispatch) => {
      try {
        dispatch({ type: duck.types.GET_RAG_SCORE, analytics: null , accumulativeAnalytics: null});
        let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
       
        const groupId = companyInfo.groupId;

        let data = {
          groupId
        }
        
        const response = await axios.get(ragAnalytics.getGroups , {params:data});
        let subGroups = response.data.data;
        dispatch({ type: duck.types.GET_GROUPS, groupList: subGroups });

      }
      catch (e) {
      }
    },
    getCardinalViolations: (id , data) => async (dispatch) => {
      try {
        dispatch({ type: duck.types.IS_LOADING, isLoading: true });
        const response = await axios.post(ragAnalytics.cardinalViolations, {
          id,
          data
        });
        dispatch({type: duck.types.GET_VIOLATIONS , cardinalViolations:response.data.data})
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });
      } catch (error) {
        
      }
    }
  })

})